import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { globals } from '../globals';
import ContactSheet from './ContactSheet';
import './Collections.css';

export default function CollectionPhotos() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchPhotos = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await axios.get(`${globals.homepageUrl}/php/get-collection-photos.php`, {
          params: { id }
        });

        if (res.data.success) {
          // il PHP restituisce percorsi relativi: aggiungo il prefisso del sito
          setPhotos(
            res.data.photos.map(p => ({ ...p, src: `${globals.homepageUrl}${p.src}` }))
          );
        } else {
          setError('Errore nel recupero delle foto della collection.');
        }
      } catch (err) {
        setError('Errore di rete o server.');
      } finally {
        setLoading(false);
      }
    };

    fetchPhotos();
  }, [id]);
  return (
    <div className="collections-container">
      <button className="collections-back-button" onClick={() => navigate(-1)}>
        ← Indietro
      </button>

      {loading && <p>Caricamento delle foto...</p>}
      {error && <p className="error">{error}</p>}
      {!loading && !error && photos.length === 0 && (
        <p>Questa collection non contiene ancora foto.</p>
      )}

    {photos.length > 0 && <ContactSheet key={id} photos={photos} collectionId={id} />}
    </div>
 
);
}